export default {
  backButton: 'Back to company report',
  title: 'Company Report',
};
